import { PositionsOrVirtualPortfolioPlanStats } from "@fartherfinance/frontend/api/Investment/request/postPositionsOrVirtualPortfolioPlanStats";
import { Entry } from "@fartherfinance/frontend/api/Investment/types";
import {
  TransitionProposalId,
  TransitionProposalPerformanceMetric,
} from "@fartherfinance/frontend/api/TransitionProposals/types";
import { PortfolioPlanId } from "@fartherfinance/frontend/api/Types";

import { AssetClassification } from "@src/multiCustodian/components/Portfolios/AssetAllocationPieChart/AssetAllocationPieChart";

interface VirtualPortfolioProps {
  portfolioPlanId: PortfolioPlanId;
  entries?: Entry[] | undefined;
  metricVisibilitySettings?: Record<string, boolean> | undefined;
  onToggleMetricVisibility?: (
    key: TransitionProposalPerformanceMetric
  ) => () => void;
  disableMetricVisibilityToggle?: boolean;
  onError?: (hasError: boolean) => void;
}

interface TransitionProposalProps {
  transitionProposalId: TransitionProposalId;
  getClassificationFromFinMason?: boolean;
  metricVisibilitySettings?: Record<string, boolean> | undefined;
  onToggleMetricVisibility?: (
    key: TransitionProposalPerformanceMetric
  ) => () => void;
  disableMetricVisibilityToggle?: boolean;
  onError?: (hasError: boolean) => void;
}

export type TransitionProposalDetailsProps =
  | VirtualPortfolioProps
  | TransitionProposalProps;

export type InvalidPositions = string[];

export interface TransitionProposalDetailsData {
  classifications: AssetClassification[];
  hasErrorClassifications: boolean;
  hasErrorPortfolioStats: boolean;
  isLoadingClassifications: boolean;
  isLoadingPortfolioStats: boolean;
  portfolioStats: PositionsOrVirtualPortfolioPlanStats | undefined;
  invalidPositions: InvalidPositions;
}

export function isVirtualPortfolioPlan(
  props: VirtualPortfolioProps | TransitionProposalProps
): props is VirtualPortfolioProps {
  return (props as VirtualPortfolioProps).hasOwnProperty("portfolioPlanId");
}
